<template>
  <div class="ibox float-e-margins mass-panel mass-config-panel">
    <div class="ibox-title">
      <h5>{{ labels.globalConfig }}</h5>
      <div class="ibox-tools">
        <a class="collapse-link">
          <i class="fa fa-chevron-up"></i>
        </a>
      </div>
    </div>
    <div class="ibox-content mass-config-content">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label>{{ labels.nodeVersion }}</label>
            <select :value="globalConfig.node_version_id" class="form-control input-sm"
                    @change="updateGlobalConfig('node_version_id', readSelectedValue($event))">
              <option value="">{{ labels.defaultOption }}</option>
              <option v-for="nv in nodeVersions" :key="nv.id" :value="nv.id">{{ nv.version }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>{{ labels.javaVersion }}</label>
            <input :value="globalConfig.java_version" class="form-control input-sm" placeholder="z.B. 21"
                   type="text"
                   @input="updateGlobalConfig('java_version', $event.target.value)">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ labels.iosVersion }}</label>
            <input :value="globalConfig.ios_version" class="form-control input-sm" placeholder="z.B. 4.0.0"
                   type="text"
                   @input="updateGlobalConfig('ios_version', $event.target.value)">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ labels.androidVersion }}</label>
            <input :value="globalConfig.android_version" class="form-control input-sm" placeholder="z.B. 4.0.0"
                   type="text"
                   @input="updateGlobalConfig('android_version', $event.target.value)">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>{{ labels.androidVersionCode }}</label>
            <input :value="globalConfig.android_version_code" class="form-control input-sm" placeholder="z.B. 400"
                   type="text"
                   @input="updateGlobalConfig('android_version_code', $event.target.value)">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ labels.sourceRepository }}</label>
            <select :value="globalConfig.source_repository_id" class="form-control input-sm"
                    @change="updateGlobalConfig('source_repository_id', readSelectedValue($event))">
              <option value="">{{ labels.defaultOption }}</option>
              <option v-for="repo in repositories" :key="repo.id" :value="repo.id">{{ repo.name }} ({{
                  repo.slug
                }})
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ labels.sourceBranch }}</label>
            <select :disabled="!globalConfig.source_repository_id || branchesLoading"
                    :value="globalConfig.source_branch_id"
                    class="form-control input-sm"
                    @change="updateGlobalConfig('source_branch_id', readSelectedValue($event))">
              <option value="">{{ branchesLoading ? 'Wird geladen...' : labels.defaultOption }}</option>
              <option v-for="branch in branches" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
            </select>
            <span v-if="!globalConfig.source_repository_id" class="small text-muted">Wählen Sie zuerst ein Quell-Repository aus.</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group m-b-none">
            <label>{{ labels.whatsNew }}</label>
            <textarea :value="globalConfig.whats_new" class="form-control input-sm" rows="2"
                      @input="updateGlobalConfig('whats_new', $event.target.value)"></textarea>
          </div>
        </div>
      </div>
      <div class="mass-delivery-card">
        <div class="mass-delivery-head">
          <div>
            <span class="mass-section-title">Build-Ziel</span>
            <strong>Plattformen und Veröffentlichung</strong>
            <small>Wählen Sie zuerst, was gebaut wird. Publishing-Ziele erscheinen nur für aktive Plattformen.</small>
          </div>
          <label :class="{'is-enabled': includePublishing}" class="mass-publish-switch">
            <input :checked="includePublishing" type="checkbox"
                   @change="$emit('update-include-publishing', $event.target.checked)">
            <span class="mass-switch-control"></span>
            <span>{{ labels.includePublishing }}</span>
          </label>
        </div>

        <div class="mass-platform-grid">
          <div class="mass-platform-column">
            <label :class="{'is-selected': platforms.ios}" class="mass-platform-card">
              <input :checked="platforms.ios" type="checkbox"
                     @change="updatePlatform('ios', $event.target.checked)">
              <span class="mass-platform-check"><i class="fa fa-check"></i></span>
              <span class="mass-platform-icon mass-platform-ios"><i class="fa fa-apple"></i></span>
              <span>
                <strong>iOS</strong>
                <small>{{ platforms.ios ? 'Ausgewählt' : 'Nicht ausgewählt' }} · IPA / Apple Pipeline</small>
              </span>
            </label>

            <div v-if="includePublishing"
                 :class="{'is-disabled': !platforms.ios}"
                 class="mass-publishing-card">
              <div class="mass-publishing-title">
                <span class="mass-platform-icon mass-platform-ios"><i class="fa fa-apple"></i></span>
                <div>
                  <strong>iOS Publishing</strong>
                  <small v-if="platforms.ios">TestFlight oder öffentliche App-Store-Einreichung</small>
                  <small v-else>Aktivieren Sie iOS, um diesen Kanal zu nutzen.</small>
                </div>
              </div>
              <div class="mass-segmented-control">
                <label :class="{'is-active': globalConfig.ios_publishing_type === ''}">
                  <input :checked="globalConfig.ios_publishing_type === ''" :disabled="!platforms.ios" type="radio"
                         value=""
                         @change="updateGlobalConfig('ios_publishing_type', '')">
                  {{ labels.defaultOption }}
                </label>
                <label :class="{'is-active': globalConfig.ios_publishing_type === 'test_flight'}">
                  <input :checked="globalConfig.ios_publishing_type === 'test_flight'" :disabled="!platforms.ios"
                         type="radio" value="test_flight"
                         @change="updateGlobalConfig('ios_publishing_type', 'test_flight')">
                  TestFlight
                </label>
                <label :class="{'is-active': globalConfig.ios_publishing_type === 'app_store'}">
                  <input :checked="globalConfig.ios_publishing_type === 'app_store'" :disabled="!platforms.ios"
                         type="radio" value="app_store"
                         @change="updateGlobalConfig('ios_publishing_type', 'app_store')">
                  App Store
                </label>
              </div>
            </div>
          </div>

          <div class="mass-platform-column">
            <label :class="{'is-selected': platforms.android}" class="mass-platform-card">
              <input :checked="platforms.android" type="checkbox"
                     @change="updatePlatform('android', $event.target.checked)">
              <span class="mass-platform-check"><i class="fa fa-check"></i></span>
              <span class="mass-platform-icon mass-platform-android"><i class="fa fa-android"></i></span>
              <span>
                <strong>Android</strong>
                <small>{{ platforms.android ? 'Ausgewählt' : 'Nicht ausgewählt' }} · APK / AAB Pipeline</small>
              </span>
            </label>

            <div v-if="includePublishing"
                 :class="{'is-disabled': !platforms.android}"
                 class="mass-publishing-card">
              <div class="mass-publishing-title">
                <span class="mass-platform-icon mass-platform-android"><i class="fa fa-android"></i></span>
                <div>
                  <strong>Android Publishing</strong>
                  <small v-if="platforms.android">Interner Track oder öffentliche Play-Store-Auslieferung</small>
                  <small v-else>Aktivieren Sie Android, um diesen Kanal zu nutzen.</small>
                </div>
              </div>
              <div class="mass-segmented-control">
                <label :class="{'is-active': globalConfig.android_publishing_type === ''}">
                  <input :checked="globalConfig.android_publishing_type === ''" :disabled="!platforms.android" type="radio"
                         value=""
                         @change="updateGlobalConfig('android_publishing_type', '')">
                  {{ labels.defaultOption }}
                </label>
                <label :class="{'is-active': globalConfig.android_publishing_type === 'internal'}">
                  <input :checked="globalConfig.android_publishing_type === 'internal'" :disabled="!platforms.android"
                         type="radio" value="internal"
                         @change="updateGlobalConfig('android_publishing_type', 'internal')">
                  Internal
                </label>
                <label :class="{'is-active': globalConfig.android_publishing_type === 'play_store'}">
                  <input :checked="globalConfig.android_publishing_type === 'play_store'" :disabled="!platforms.android"
                         type="radio" value="play_store"
                         @change="updateGlobalConfig('android_publishing_type', 'play_store')">
                  Play Store
                </label>
              </div>
            </div>
          </div>
        </div>

        <div v-if="includePublishing && !platforms.ios && !platforms.android" class="mass-publishing-hint">
          <i class="fa fa-info-circle"></i> Wählen Sie mindestens eine Plattform, um Publishing-Ziele festzulegen.
        </div>

        <div class="mass-start-action">
          <button :disabled="startDisabled || isStartingRun" class="btn btn-primary mass-start-button"
                  @click="$emit('start-builds')">
            <i :class="isStartingRun ? 'fa-spinner fa-spin' : 'fa-play'" class="fa"></i>
            {{ isStartingRun ? labels.startingRun : labels.startBuilds }}
          </button>
          <div v-if="startFeedbackMessage" class="mass-start-feedback">
            <i class="fa fa-check-circle"></i> {{ startFeedbackMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Object,
      required: true,
    },
    globalConfig: {
      type: Object,
      required: true,
    },
    nodeVersions: {
      type: Array,
      required: true,
    },
    repositories: {
      type: Array,
      required: true,
    },
    branches: {
      type: Array,
      required: true,
    },
    branchesLoading: {
      type: Boolean,
      required: true,
    },
    platforms: {
      type: Object,
      required: true,
    },
    includePublishing: {
      type: Boolean,
      required: true,
    },
    startDisabled: {
      type: Boolean,
      required: true,
    },
    isStartingRun: {
      type: Boolean,
      required: true,
    },
    startFeedbackMessage: {
      type: String,
      required: true,
    },
  },
  methods: {
    readSelectedValue(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      if (selectedOption && Object.prototype.hasOwnProperty.call(selectedOption, '_value')) {
        return selectedOption._value;
      }
      return event.target.value;
    },
    updateGlobalConfig(key, value) {
      this.$emit('update-global-config', {key, value});
    },
    updatePlatform(platform, value) {
      this.$emit('update-platform', {platform, value});
    },
  },
};
</script>
